import { Person } from "./person";
import { Role } from "./rol";
import { SignatureDivisionArea } from "./signature-division-area";

export class User {
    id: number = 0;
    email!: string;
    active: boolean = false;
    person: Person = new Person();

    roles: Role[] = [];
    signatureDivisionAreas: SignatureDivisionArea [] = [];
}